import { gql } from '@apollo/client';

export const fetchEndCustomerContactsInPPC = gql`
  query fetchEndCustomerContactsInPPC($searchParams: EndCustomerContactSearchParams) {
    endCustomerContacts(searchParams: $searchParams) {
      totalCount
      nodes {
        picture
        name
        accountId
        email
      }
    }
  }
`;
